const VT_TOKEN_KEY = 'vt_token'

export const getToken = () => {
  return window.localStorage.getItem(VT_TOKEN_KEY)
}

export const saveToken = (token) => {
  window.localStorage.setItem(VT_TOKEN_KEY, token)
}

export const destroyToken = () => {
  window.localStorage.removeItem(VT_TOKEN_KEY)
}

export default { getToken, saveToken, destroyToken }
